import { Button, useToast } from "alm-react-components";
import parse from "html-react-parser";
import moment from "moment-timezone";
import {
  useContext,
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
} from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router";
import { useSearchParams } from "react-router-dom";
import {  ApiErrorCode, APPROUTES, ErrorType, SubscriptionStatus, Tag } from "../../assets/constants/constants";
import ProgramOverview from "../../assets/images/program-overview.jpg";
import { AppContext } from "../../context/AppProvider";
import useQuaterListHook from "../../hooks/useQuaterListHook";
import useSubscription from "../../hooks/useSubscription";
import getLocalizedContent from "../../lib/getLocalizedMetaData";
import PlayIcon from '../../assets/images/svgicons/play.svg';
import {
  badgeUrl,
  cleanHtmlSpaces,
  covertDateUtcToIST,
  getInstructorInfo,
  isEnrollmentDateAvailable,
  limitOverview,
} from "../../lib/utils";
import { apis } from "../../services/alm";
import getFAQ from "../../services/faq";
import EnrollUser from "../common/EnrollUser";
import PageLoader from "../common/loader/PageLoader";
import MeetingCalendar from "../common/MeetingCalendar";
import ProgramPlayer from "../common/player/ProgramPlayer";
import accordionArrowImg from "../../assets/images/svgicons/accordion-arrow.svg";
import withAlmToken from "../common/withAlmToken";
import LearningProgramList from "../learning-program/LearningProgramList";
import { Curriculum } from "./Curriculum";
import FaqList from "./FaqList";
import InstructorView from "./InstructorView";

const ProgramOverView = () => {
  const { t } = useTranslation();
  const { toast } = useToast();
  const { state } = useContext(AppContext);
  const [resourcesIds, setResourcesIds] = useState<any[]>([]);
  const [upcomingDate, setUpcomingDate] = useState<string | null>(null);
  const [overViewData, setOverViewData] = useState<any>({
    bannerUrl: "",
    jobAid: "",
    overView: "",
    name: "",
    instanceId: "",
    imageUrl: "",
    enrolledProgram: "",
    tags: [],
  });
  const [sectionData, setSectionData] = useState<any>({
    subLos: [],
    included: [],
  });
  const [accordianData, setAccordianData] = useState<any[]>([]);
  const { getQuaterStartData } = useQuaterListHook();
  const navigate = useNavigate();
  const [playCourse, setPlayCourse] = useState(false);
  const { callSubscription, subscriptionResponse } = useSubscription();
  const [questions, setQuestions] = useState<any>([]);
  const [query] = useSearchParams();
  const location = useLocation();
  const year: any = location?.state?.year;
  const programCountEachQuarter: any = location?.state?.programCountEachQuarter;
  const programId: any = query.get('programId');
  const isEnrolled: any = query.get('enrolled');
  

  const [enrollProgramInstanceId, setEnrollMentData] = useState('');
  const [activeRef, setActiveRef] = useState<any>('');
  const [data, setData] = useState<any>([]);
  const [instructors, setInstructors] = useState<any>([]);
  const [isEnroll, setIsEnroll] = useState(false);
  const [quaterTag, setQuaterTag] = useState("");
  const [loading, setLoading] = useState(true);
  const [islisting, setIsListing] = useState(false);
  const [introductionVideo, setIntroductionVideo] = useState<any>();
  useEffect(() => {
    if (overViewData) {
      const quaterData = getQuaterStartData(
        overViewData?.tags?.find((res: any) => res === year)?.split("-")[0]
      );
      setQuaterTag(quaterData?.quarter + "-" + quaterData?.year);
    }
  }, [overViewData]);

  useEffect(() => {
    if (state.user) {
      if (!state.user?.corporateAccountId)
        callSubscription("valid");
    }
  }, [state.user]);
  useEffect(() => {
    const hasSubscription=   !state.user?.corporateAccountId ? (subscriptionResponse?.subscriptionStatus === SubscriptionStatus.active ||
      subscriptionResponse?.subscriptionStatus ===
      SubscriptionStatus.trial) &&
      programId &&
      quaterTag :true
    if (hasSubscription) {
      programOverViewDetails();
      quaterData();
    }
  }, [subscriptionResponse, programId, quaterTag]);
  //
  const programOverViewDetails = async () => {

    try {
      // Get the program details from API and update the state.
      // Also, get the introduction video URL from the API and update the state.
      const response: any = await apis.getProgramList(programId);
      // Get the introduction video URL from the API and update the state.
      if (response.code === ApiErrorCode.objectDoesntExist) {
        navigate(`${APPROUTES.error}/${ErrorType.programEnrollment}`);
        return;
      }

      setData(response);

      const content = getLocalizedContent(
        response?.data?.attributes?.localizedMetadata
      );
      const obj = {
        bannerUrl: response?.data?.attributes?.bannerUrl,
        jobAid: response?.data?.relationships?.supplementaryLOs?.data[0]?.id,
        localizedMetadata: content,
        overView: content.overview,
        name: content?.name,
        instanceId: response?.data?.relationships?.instances?.data[0]?.id,
        enrolledProgram: response?.data?.relationships?.enrollment?.data?.id,
        imageUrl: response?.data?.attributes?.imageUrl,
        tags: response?.data?.attributes.tags,
      };
      setOverViewData(obj);
      setSectionData({
        subLos: response?.data?.relationships?.subLOs?.data,
        included: response?.included,
      });
      setLoading(false);
    } catch (error) {
      console.log("error", error);
    }
  };
  const quaterData = async () => {
    try {
      const response: any = await apis.getLearningProgram(quaterTag);
      const enrolledData = response?.data?.filter((item: any) => {
        return item.relationships.enrollment;
      });
      setEnrollMentData(enrolledData[0]?.relationships?.instances?.data[0]?.id);
    } catch (e) {
      console.log("error", e);
    }
  };
  const filterationOfData = (): any[] => {
    const arr = [];
    const loIdsArr = [];
    for (let i = 0; i < sectionData?.subLos?.length; i++) {
      for (let j = 0; j < sectionData.included?.length; j++) {
        if (sectionData.included[j].id === sectionData?.subLos[i].id) {
          if (
            sectionData.included[j]?.attributes?.tags?.includes(
              Tag.introductionVideo
            ) ||
            sectionData.included[j]?.attributes?.tags?.includes(
              Tag.overviewIntroVideo
            ) ||
            sectionData.included[j]?.attributes?.tags?.includes(Tag.doNotShow)
          ) {
            //Set introduction module
            if (
              sectionData.included[j]?.attributes?.tags?.includes(
                Tag.overviewIntroVideo
              )
            )
              setIntroductionVideo(sectionData.included[j].id);
            // hide week detail from listing ui
          } else {
            loIdsArr.push(sectionData.included[j]?.relationships?.subLOs?.data);
            arr.push(sectionData.included[j]);
          }
        }
      }
    }

    // Step 1: Flatten loIdsArr and extract learning instances
    const mergedArray = loIdsArr.flat();
    const learningIntanceIdsData = mergedArray
      .flatMap((idObj) =>
        sectionData.included
          ?.filter((item: any) => item.id === idObj?.id)
          .map((item: any) => item?.relationships?.instances?.data)
      )
      .flat();

    // Step 2: Extract learning object resource IDs (loResourseIds)
    const loResourseIdsData = learningIntanceIdsData
      .flatMap((idObj) =>
        sectionData.included
          ?.filter((item: any) => item.id === idObj?.id)
          .map((item: any) => item?.relationships?.loResources?.data)
      )
      .flat();

    // Step 3: Extract resources (resourcesIdData)
    const resourcesIdData = loResourseIdsData
      .flatMap((idObj) =>
        sectionData.included
          ?.filter((item: any) => item.id === idObj?.id)
          .map((item: any) => item?.relationships?.resources?.data)
      )
      .flat();

    // Step 4: Filter for 'Virtual Classroom' content type and extract dateStart
    const resourcesIds = resourcesIdData.flatMap((item) =>
      sectionData.included
        .filter(
          (includedItem: any) =>
            includedItem.id === item?.id &&
            includedItem?.attributes?.contentType === "Virtual Classroom"
        )
        .map((includedItem: any) => includedItem?.attributes?.dateStart)
    );
    setResourcesIds(resourcesIds);
    return [arr, loResourseIdsData];
  };

  // const handleChatBot = () => {
  //   dispatch({ type: ActionType.GLOBAL_CHATBOT_KEY, payload: true });
  // }

  useEffect(() => {
    // Once data is processed, set the upcoming date based on resourcesIds
    if (resourcesIds.length > 0) {
      const currentDate = moment(); // Get today's date

      // Filter the resourcesIds to only include upcoming dates
      const upcomingDates = resourcesIds.filter((date) =>
        moment(date).isAfter(currentDate)
      );

      // Sort the upcoming dates to get the earliest one
      const sortedUpcomingDates = upcomingDates.sort((a, b) =>
        moment(a).isBefore(b) ? -1 : 1
      );

      // Get the first upcoming date (earliest one)
      const firstUpcomingDate =
        sortedUpcomingDates.length > 0 ? sortedUpcomingDates[0] : null;

      // If there's an upcoming date, convert it to the user's timezone using covertDateUtcToIST function
      const displayDate = firstUpcomingDate
        ? covertDateUtcToIST(firstUpcomingDate, state?.user?.timeZoneCode)
        : null;

      if (displayDate) {
        const formattedDate = displayDate.format("HH:mm").replace("..", ".");
        const dayOfWeek = displayDate.format("dddd");
        setUpcomingDate(`${dayOfWeek}, ${formattedDate}`);
      } else {
        setUpcomingDate(t('Program.noUpcomingMeetings'));
      }
    }
  }, [resourcesIds]);

  const getFAQsDetails = () => {
    getFAQ().then((response: any) => {
      setQuestions(response?.data);
    });
  };
  useEffect(() => {
    getFAQsDetails();
  }, []);

  useEffect(() => {
    if (sectionData) {
      const [arr] = filterationOfData();
      setAccordianData(arr);
    }
  }, [sectionData]);

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
    if (history.scrollRestoration) {
      history.scrollRestoration = "manual";
    }
  }, [programId]);
  const overViewRef = useRef(null);
  const curriculumRef = useRef(null);
  const teachingTeamRef = useRef(null);
  const startDateRef = useRef(null);
  const scheduleRef = useRef(null);
  const faqRef = useRef(null);
  const scrollToPosition = (ref: any, index: number) => {
    setActiveRef(index);
    ref.current.scrollIntoView({
      behavior: "smooth",
      block: "center",
      inline: "start",
    });
  };
  const leadershipProgramData: any = [
    { name: t('Common.overview'), ref: overViewRef },
    { name: t('ProgramOverview.curriculumTitle'), ref: curriculumRef },
    { name: t('ProgramOverview.teachingTeamTitle'), ref: teachingTeamRef },
    { name: t('Program.startDate'), ref: startDateRef },
    { name: t('Common.schedule'), ref: scheduleRef },
    { name: t('ProgramOverview.faqTitle'), ref: faqRef },
  ];

  useEffect(() => {
    const response = getInstructorInfo(data);
    setInstructors(response);
  }, [data]);

  const playIntroductionVideo = (id: string | undefined) => {
    if (id) {
      setPlayCourse(true);
    } else {
      toast({ description: t("Common.errorPlayingVideo"), variant: "error" });
    }
  };

  const date = getQuaterStartData("", year)?.start;
  const beforeStartDate = moment(date)
    .subtract(14, "days")
    .format("MMMM D, YYYY");
  const startDate = moment(date).format("MMMM D, YYYY");
  const instanceId = overViewData?.instanceId || '';
  const isIncluded = sectionData?.included || false;
  const selectedYear = overViewData?.tags?.find((tag: any) => tag === year)?.split("-")[0] || '';
  const quarterStartDate = getQuaterStartData(selectedYear)?.start;
  const shouldHighlight = isEnrollmentDateAvailable(quarterStartDate);
  const badgeClassName = `ms-8 h-[60px] ${shouldHighlight ? "yellow" : ""}`;
  const badgeSrc = badgeUrl(instanceId, isIncluded);
  return (
    <>
      <div className="flex-grow">
        {loading ? (
          <PageLoader />
        ) : (
          <>
            <section
              style={{ backgroundImage: `url('${overViewData?.bannerUrl}')` }}
              className={`bg-no-repeat bg-blend-multiply bg-cover bg-center mb-10`}
            >
              <div className="w-[100%] mx-auto xl:px-32 lg:px-8 md:px-8 px-5 py-6 lg:mb-6">
                <div className="lg:flex lg:items-center lg:justify-between">
                  <Button
                    onClick={() => navigate(isEnrolled ? -2 : -1)}
                    variant="default"
                    className="dark:bg-fillMidGrayCard w-6 h-6 pl-0 top-0 mr-3 mt-[2px]"
                  >
                    <img src={accordionArrowImg} alt={" "} className="logo cursor-pointer h-[14px] ml-4 rotate-180" />
                  </Button>
                  <MeetingCalendar />
                </div>
              </div>

              <div className="pb-8 lg:px-8 xl:px-32 xl:pt-18 md:py-14 mx-auto lg:py-16 text-center w-[100%] md:px-8 max-md:px-5">
                <h4
                  className="mb-2 lg:text-2xl uppercase font-barlowLight text-left tracking-wider"
                  dangerouslySetInnerHTML={{
                    __html: t("Program.text"),
                  }}
                ></h4>

                <h1 className="mb-8 leading-none font-barlowRegular text-white lg:text-4xl xl:text-6xl text-left">
                  {overViewData?.name}
                </h1>
                <p className="mb-16 text-lg font-opensansRegular lg:text-xl text-left lg:w-[40%] md:w-[60%]">
                  {limitOverview(overViewData?.localizedMetadata?.description)}
                </p>
                {programId && overViewData.instanceId != "" && (
                  <EnrollUser
                    programId={programId}
                    enrollProgramInstanceId={enrollProgramInstanceId}
                    width={"56"}
                    instanceId={overViewData.instanceId}
                    quaterTag={""}
                    quaterData={quaterData}
                    name={overViewData?.name}
                    isEnroll={isEnroll}
                    setIsEnroll={setIsEnroll}
                    quaterStartDate={getQuaterStartData(
                      overViewData?.tags
                        ?.find((res: any) => res === year)
                        ?.split("-")[0]
                    )}
                    year={year?.split("-")[1]}
                    programCountEachQuarter={programCountEachQuarter}
                    setIsListing={setIsListing}
                    fullYear={year}
                  />
                )}
              </div>
            </section>
            <section className="md:py-14 xl:px-32 max-md:px-5 lg:px-8 flex lg:space-x-24 landscape:lg:space-x-10 md:space-x-0 md:space-y-10 grow-0 md:px-8 md:flex-wrap justify-center break-words mx-0">
              <div className="bg-fillMidGrayCard  sticky top-16 pb-8 px-8 pt-6 rounded-xl  h-[max-content] max-lg:hidden w-[360px]">
                <div className="flex items-start justify-between">
                  <div className="flex items-center pb-6 gap-4">
                    <p className="w-[8px] h-[8px] rounded-lg bg-red-500 mt-2"></p>
                    <div className="flex flex-col">
                      {overViewData?.name
                        ?.split(" ")
                        .map((res: any, index: number) => {
                          return (
                            <h4
                              key={`res-${index}`}
                              className="break-normal lg:text-xl xl:text-2xl"
                            >
                              {res}
                            </h4>
                          );
                        })}
                    </div>
                  </div>
                  <img
                    className={badgeClassName}
                    src={badgeSrc}
                    alt=""
                  />
                </div>
                <ul className="mt-5 vertical-line landscape:xl:mr-0 landscape:lg:mr-0">
                  {leadershipProgramData?.map((res: any, index: any) => (
                    <li
                      key={`li-${index}`}
                      className={`w-full cursor-pointer ${index === activeRef ? "yellow" : ""
                        } px-2 py-2 text-base dark:border-gray-600`}
                      onClick={() => scrollToPosition(res?.ref, index)}
                      dangerouslySetInnerHTML={{ __html: t(res?.name) }}
                    ></li>
                  ))}
                </ul>
                {programId && overViewData.instanceId != "" && (
                  <EnrollUser
                    programId={programId}
                    enrollProgramInstanceId={enrollProgramInstanceId}
                    width={"full"}
                    instanceId={overViewData.instanceId}
                    quaterTag={""}
                    quaterData={quaterData}
                    isEnroll={isEnroll}
                    setIsEnroll={setIsEnroll}
                    name={overViewData?.name}
                    quaterStartDate={getQuaterStartData(
                      overViewData?.tags
                        ?.find((res: any) => res === year)
                        ?.split("-")[0]
                    )}
                    year={year?.split("-")[1]}
                    programCountEachQuarter={programCountEachQuarter}
                    setIsListing={setIsListing}
                    fullYear={year}
                  />
                )}{" "}
              </div>
              <div
                className="flex-1 break-words "
                style={{ wordBreak: "break-word" }}
              >
                <div
                  ref={overViewRef}
                  className="border-b  border-[#434343] pb-4"
                >
                  <h4
                    className="font-light tracking-wider text-base font-barlowLight"
                    dangerouslySetInnerHTML={{
                      __html: t("ProgramOverview.overviewTitle"),
                    }}
                  ></h4>

                  <p
                    className="mt-2 font-opensansLight tracking-wider text-editor-dynamic-class"
                    dangerouslySetInnerHTML={{
                      __html: cleanHtmlSpaces(t("ProgramOverview.overview")),
                    }}
                  ></p>

                  <div className="mt-4 text-base font-opensansLight tracking-wider ql-editor">
                    {overViewData?.localizedMetadata?.richTextOverview
                      ? parse(overViewData?.localizedMetadata?.richTextOverview)
                      : null}
                  </div>
                  {playCourse ? (
                    <div className="col-span-2 pb-4">
                      <div className={`mb-6 w-auto h-[568px] `}>
                        <ProgramPlayer
                          cid={introductionVideo}
                          goBackUrl={`/program-overview/${programId}`}
                          fullScreen={true}
                          playVideo={setPlayCourse}
                        />
                      </div>
                    </div>
                  ) : (
                    <div className="relative max-w-[689px]">
                    <img
                    src={ProgramOverview}
                    alt=""
                    className="mt-8 w-auto rounded-xl"
                    onClick={() => playIntroductionVideo(introductionVideo)}
                    />
                    <img src={PlayIcon} alt={' '} onClick={() => playIntroductionVideo(introductionVideo)} className="absolute cursor-pointer center-icon" />
                    </div>
                  )}
                </div>
                <div
                  ref={curriculumRef}
                  className="pb-24 border-b border-[#434343] mt-16 go-to-top-overview"
                >
                  <h4
                    className="font-light tracking-wider text-base font-barlowLight mb-5"
                  >{t("ProgramOverview.curriculumTitle")}</h4>

                  <p
                    className="font-opensansLight tracking-wide mb-3 text-editor-dynamic-class"
                    dangerouslySetInnerHTML={{
                      __html: cleanHtmlSpaces(
                        t("ProgramOverview.lessonsDescription")
                      ),
                    }}
                  ></p>

                  <Curriculum accordianData={accordianData} />
                </div>

                <div ref={teachingTeamRef} className="mt-16 mb-24">
                  <h4
                    className="font-light tracking-wider text-base font-barlowLight mb-4 "
                  >{t("ProgramOverview.teachingTeamTitle")}</h4>

                  <p
                    className="font-opensansLight tracking-wide mb-3 text-editor-dynamic-class"
                    dangerouslySetInnerHTML={{
                      __html: cleanHtmlSpaces(
                        t("ProgramOverview.coachesDescription")
                      ),
                    }}
                  ></p>

                  <InstructorView instructors={instructors} />
                </div>
                <div
                  ref={startDateRef}
                  className="border-b border-t border-[#434343]  mt-16 pb-24 relative"
                >
                  <h4
                    className="font-light tracking-wider text-base font-barlowLight mt-12"
                    dangerouslySetInnerHTML={{ __html: t("ProgramOverview.startTitle") }}
                  ></h4>

                  <p className="font-sans text-left tracking-wider mt-6 text-editor-dynamic-class"
                    dangerouslySetInnerHTML={{
                      __html: cleanHtmlSpaces(
                        t("ProgramOverview.enrollToYourProgram")
                      ),
                    }}
                  />

                  <p
                    className="mt-12 text-lg font-opensansSemiBold tracking-wide"
                    dangerouslySetInnerHTML={{ __html: t("Program.startDate") }}
                  ></p>

                  <p
                    className="mt-2 font-opensansLight tracking-wide text-editor-dynamic-class"
                    dangerouslySetInnerHTML={{
                      __html: cleanHtmlSpaces(t("ProgramOverview.start")),
                    }}
                  ></p>

                  <div className="relative bg-[#212930] pb-6 pt-8 rounded-2xl mt-3 mb-12 px-8">
                    <div className="flex items-center m-5 text-xs border bg-[#181818] p-1 mt-6 absolute top-0 left-3 rounded-md text-white px-1.5">
                      <p className="w-[8px] h-[8px] rounded-lg bg-red-500"></p>
                      <p
                        className="mx-2 uppercase text-red-50"
                        dangerouslySetInnerHTML={{
                          __html: t("Program.liveProgram"),
                        }}
                      ></p>
                    </div>
                    <p
                      className="text-2xl mt-8 opensansSemiBold"
                      dangerouslySetInnerHTML={{
                        __html: `${t("Program.startDate")}: ${startDate}`,
                      }}
                    ></p>

                    <p
                      className="text-lg mt-2"
                      dangerouslySetInnerHTML={{
                        __html: `${t(
                          "Program.startDateMsg"
                        )} : ${beforeStartDate}`,
                      }}
                    ></p>

                    <p
                      className="text-base mt-4 w-9/12 font-opensansRegular text-formTextMute"
                      dangerouslySetInnerHTML={{
                        __html: t("Program.enrollmentNotification"),
                      }}
                    ></p>
                  </div>
                  {programId && overViewData.instanceId != "" && (
                    <EnrollUser
                      programId={programId}
                      enrollProgramInstanceId={enrollProgramInstanceId}
                      width={"56"}
                      instanceId={overViewData.instanceId}
                      quaterTag={""}
                      quaterData={quaterData}
                      name={overViewData?.name}
                      setIsEnroll={setIsEnroll}
                      isEnroll={isEnroll}
                      quaterStartDate={getQuaterStartData(
                        overViewData?.tags
                          ?.find((res: any) => res === year)
                          ?.split("-")[0]
                      )}
                      year={year?.split("-")[1]}
                      programCountEachQuarter={programCountEachQuarter}
                      setIsListing={setIsListing}
                      fullYear={year}
                    />
                  )}
                </div>
                <div
                  ref={scheduleRef}
                  className="border-b border-[#434343] mt-16 pb-24 relative "
                >
                  <div className="">
                    <h4
                      className="font-light tracking-wider text-base font-barlowLight mt-12"
                      dangerouslySetInnerHTML={{
                        __html: t("Common.schedule"),
                      }}
                    ></h4>

                    <p
                      className="font-sans text-left tracking-wider mt-6 text-editor-dynamic-class"
                      dangerouslySetInnerHTML={{
                        __html: cleanHtmlSpaces(
                          t("ProgramOverview.onlineMeetingsDescription")
                        ),
                      }}
                    ></p>

                    <div className="relative bg-[#212930] pb-6 pt-8 rounded-2xl mt-3 mb-12 px-8 flex justify-between max-sm:flex-col md:flex-row items-start">
                      <div className=" lg:pr-6">
                        <div className="flex items-center m-5 text-xs border bg-[#181818] p-1 mt-6 absolute top-0 left-3 rounded-md text-white px-1.5">
                          <p className="w-[8px] h-[8px] rounded-lg bg-red-500"></p>
                          <p
                            className="mx-2 uppercase text-red-50"
                            dangerouslySetInnerHTML={{
                              __html: t("Program.liveProgram"),
                            }}
                          ></p>
                        </div>
                        <p
                          className="text-2xl mt-8 opensansSemiBold"
                          dangerouslySetInnerHTML={{
                            __html: t("Program.liveMeetings"),
                          }}
                        ></p>

                        <div>
                          <span
                            dangerouslySetInnerHTML={{
                              __html: `${accordianData && accordianData.length
                                } ${t("Common.parts")}`,
                            }}
                          ></span>
                          <span> | </span>
                          <span
                            dangerouslySetInnerHTML={{
                              __html: upcomingDate
                                ? upcomingDate
                                : t("Program.noUpcomingMeetings"),
                            }}
                          ></span>
                        </div>
                      </div>
                      <div>
                        {programId && overViewData.instanceId != "" && (
                          <EnrollUser
                            programId={programId}
                            enrollProgramInstanceId={enrollProgramInstanceId}
                            width={"56"}
                            instanceId={overViewData.instanceId}
                            quaterTag={""}
                            quaterData={quaterData}
                            name={overViewData?.name}
                            setIsEnroll={setIsEnroll}
                            isEnroll={isEnroll}
                            quaterStartDate={getQuaterStartData(
                              overViewData?.tags
                                ?.find((res: any) => res === year)
                                ?.split("-")[0]
                            )}
                            year={year?.split("-")[1]}
                            programCountEachQuarter={programCountEachQuarter}
                            setIsListing={setIsListing}
                            fullYear={year}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <div ref={faqRef} className="mt-6 pb-12 relative go-to-top-faq">
                  <h4
                    className="uppercase font-light tracking-wider text-base font-barlowLight mt-12"


                  >{t("ProgramOverview.faqTitle")}</h4>

                  <p
                    className="font-opensansLight tracking-wide mt-3 mb-3 text-editor-dynamic-class"
                    dangerouslySetInnerHTML={{
                      __html: cleanHtmlSpaces(t("ProgramOverview.faq")),
                    }}
                  ></p>

                  <div>
                    <FaqList questions={questions} />
                  </div>

                  <div className="relative bg-[#212930] pb-6 pt-8 rounded-2xl mt-3 mb-12 px-8 flex justify-between max-sm:flex-col md:flex-row items-start">
                    <div className=" lg:pr-6">
                      <h1
                        className="text-2xl"
                        dangerouslySetInnerHTML={{
                          __html: t("ProgramOverview.gotQuestionTitle"),
                        }}
                      ></h1>

                      <p
                        className="mt-8"
                        dangerouslySetInnerHTML={{
                          __html: t("ProgramOverview.questionDescription"),
                        }}
                      ></p>
                    </div>
                    {/* <div className="flex flex-col justify-center mt-5 md:mt-0">
                      <Button
                        onClick={() => { handleChatBot() }}
                        dangerouslySetInnerHTML={{
                          __html: t("Program.sendMessageText"),
                        }}
                      />
                    </div> */}
                  </div>
                </div>
                {
                  (state?.user?.sllCorporateAccount  !== 1) && programCountEachQuarter?.length>1 &&(
                    <div>
                      <div className="flex justify-between mb-4">
                        <p className="font-light tracking-wider text-2xl lg:text-2xl xl:text-3xl font-barlowLight ">
                          <span className="text-primary pr-2">
                            {
                              overViewData?.tags
                                ?.find((res: any) => res === year)
                                ?.split("-")[0]
                            }
                          </span>
                          <span
                            className="font-barlowLight me-2"
                            dangerouslySetInnerHTML={{
                              __html: t("Program.live"),
                            }}
                          ></span>

                          <span
                            className="font-barlowLight"
                            dangerouslySetInnerHTML={{
                              __html: t("Program.text"),
                            }}
                          ></span>
                        </p>
                        <div className="flex-shrink-0 inline-flex items-center text-base font-opensansSemiBold text-gray-900 dark:text-white mb-2">
                          <Button
                            onClick={() => navigate("/home/quater-list")}
                            variant="outline"
                            className="w-full space-y-1.5 space-x-1.5 h-auto text-base border-0 font-normal bg-fillMidGrayCard py-1 md:min-h-10 md:px-14"
                          >
                            <span
                              dangerouslySetInnerHTML={{
                                __html: t("Program.seeAllPrograms"),
                              }}
                            ></span>
                          </Button>
                        </div>
                      </div>
                      {programId && (
                        <LearningProgramList
                          quaterData={getQuaterStartData(
                            overViewData?.tags
                              ?.find((res: any) => res === year)
                              ?.split("-")[0],
                            overViewData?.tags
                              ?.find((res: any) => res === year)
                              ?.split("-")[1]
                          )}
                          overviewTag={overViewData?.tags}
                          programCountEachQuarter={programCountEachQuarter}
                          year={year}
                          islisting={islisting}
                          quaterTag={quaterTag}
                        />
                      )}
                    </div>
                  ) 
                }
              </div>
            </section>
          </>
        )}
      </div>
    </>
  );
};

export default withAlmToken(ProgramOverView);
